// core
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

// services
import {CustomHttp} from '../../core/http-custom/http-custom.service';
import {UtilsService} from '../../utils/utils.service';

// models
import {ImageModel} from 'app/shared/models/image.model';

@Injectable()
export class CompanyDataServiceService {

  constructor(
    private _http: CustomHttp,
    private _utilsService: UtilsService
  ) {
  }

  public getCustomerLogo(): Observable<ImageModel> {
    return this._http.get(`/apps/umng/user/me/customer/logo`);
  }

  public updateCustomerLogo(logo?: ImageModel): Observable<any> {
    return this._http.put('/apps/umng/user/me/customer/logo', logo);
  }

  public deleteCompanyData(): Observable<any> {
    return this._http.delete('/apps/umng/user/me/customer/logo');
  }


}
